<nav class="navbar navbar-expand-sm  custom-navbar sticky-top">
    <div class="container-fluid">
        <a class="navbar-brand" href="javascript:void(0)" (click)="redirectToHomePage()"><img
            src="../../../assets/images/Corpository-logo.svg"
            onerror="this.src='./assets/images/Corpository-logo.svg';" class="logo"></a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end" id="collapsibleNavbar">
        <ul *ngIf="!isBorrowerDetailsPage" class="nav navbar-nav   ">
           
            <li class="nav-item dropdown " id="solution">
                <a href="javascript:void(0);" class="notification nav-link dropdown-toggle" style="text-decoration: none;"
                    (click)="openProductDropdown()" id="dropbtn1" data-bs-toggle="dropdown">
                    <img src="../../assets/images/app.svg"
                        style="display: block;text-align: center;margin-top: 10px;height: 22px;margin-left:40px;">
                    <span class="sm-font"
                        style="margin-left: 20px;margin-top: 40px; text-decoration: none;">Solutions</span>
                    <span class="caret sm-font"></span>
                </a>
                 
                    <ul class="dropdown-menu dropdown-menu-end" role="menu" aria-labelledby="menu1" >

                        <li *ngFor="let product of userProductsDetails">
                            <a href="javascript:void(0)"
                                *ngIf="product.label!='GST Analyze' && product.product_acess==1"
                                style="text-decoration: none;" class="dropdown-item" (click)="openUrl(product.url)">{{product.label}}</a>
                            <a href="javascript:void(0)"
                                *ngIf="product.label!='GST Analyze' && product.product_acess!=1"
                                style="text-decoration: none;" class="dropdown-item disabled">{{product.label}}</a>
                        </li>
                    </ul>
                 
            </li>
            <li class="dropdown drop-tab nav-item dropdown" id="solution">
                <a href="javascript:void(0)" (click)="hidePopUp()" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                    <img src="./assets/images/user-icon.png" class="user-icon">
                    <div style="display:inline-block;margin-top: 9px;">
                    {{userName}} <br> {{corporateName}}
                </div>
                
                </a>
                 
                    <ul class="dropdown-menu dropdown-menu-end" role="menu" aria-labelledby="menu1"  >
                        <li>
                            <a href="javascript:void(0)" class="dropdown-item" style="text-decoration: none;" (click)="logout()">Logout</a>
                        </li>
                    </ul>
                
            </li>
            <!-- <li class="dropdown open">
            <a id="user_account_id" data-toggle="dropdown" href="javascript:;" class="dropdown-toggle" aria-expanded="true">
                <br><img src="./assets/images/user-icon.png" class="user-icon"> <span title="Priyal"> {{userName}}  {{displayName}}</span><span class="caret"></span></a>
                <ul class="dropdown-menu">
                    <li><a href="javascript:;" routerlinkactive="active" id="logout">Logout</a></li>
                </ul>
        </li>-->
        </ul>
      
      </div>
    </div>
  </nav>

 
<router-outlet></router-outlet>
<div class="footer-section ">
    <div class="container-fluid row">
    <div class="col-md-3 col-sm-3 col-xs-12 ">
        <p class="footer-content" style="margin-left: 0; margin-bottom: 0;">{{footerMsg}}</p>
    </div>
    <div class="col-md-6 col-sm-6 col-xs-12 text-middle">
        <ul class="nav  footer-menu center-block">
            <li><a href="https://www.corpository.com/marketing/privacy/" target="_blank">Privacy</a></li>
            <li><a href="https://www.corpository.com/marketing/terms/" target="_blank">Terms</a></li>
            <li><a href="https://www.corpository.com/marketing/contact/" target="_blank">Contact Us</a></li>
            <!-- <li><a href="/corpository/companies/15/0/1" target="_blank">Company List</a></li>
            <li><a href="/corpository/directors/15/0/1" target="_blank">Director List</a></li> -->
        </ul>
    </div>
    <div class="col-md-3 col-sm-3 col-xs-12 text-end">
        <a class="facebook-icon" href="https://www.facebook.com/corpository/" target="_blank" title="Facebook"><i
                class="fa fa-facebook"></i> </a>
        <a class="twitter-icon" href="https://twitter.com/corpository" target="_blank" title="Twitter"><i
                class="fa fa-twitter"></i> </a>
        <a class="linkedin-icon" href="https://www.linkedin.com/company/corpository" target="_blank" title="LinkedIn"><i
                class="fa fa-linkedin"></i> </a>
    </div>
</div>
</div>